import React from "react"
import PropTypes from 'prop-types';
import resolveProps from '../../utils/resolveProps'
import clearProps from '../../utils/clearProps';

export default class Avatar extends React.Component {
  constructor(props) {
    super(props)

    this.config = {
      types : [
        {
          title : 'sm',
          isDefault : true
        },
        'md',
        'lg',
      ],
      modifiers : [
        'picture'
      ]
    }
  }

  renderNotication(notificationCount){ 
    notificationCount = Number(notificationCount)
    if(notificationCount === 0) return ''
    let content = ''
    if(notificationCount > 0 && notificationCount <= 9  ) { 
      content = notificationCount      
    } else if (notificationCount > 9) { 
      content = '+9'
    }
    return <div className="mdn-Avatar-notification mdn-Avatar-notification">
      {content}
    </div> 
  }

  render() {
    const { imageSrc, imageAlt, notificationCount, config, sm, md, lg, ...rest } = this.props
    
    let spanClassName  = 'sm';
    if(md) {
      spanClassName = 'md'
    } else if (lg) {
      spanClassName = 'lg'
    }

    return <div {...rest} className={resolveProps(this.props, this.config, 'Avatar')}>
      {
        imageSrc ? <div className="mdn-Avatar-image"> 
          <img src={imageSrc || config && config.imageSrc} alt={imageAlt || config && config.imageAlt } /> 
        </div> : <span className={"mdn-Avatar-icon mdn-Icon-minha-claro mdn-Icon--"+spanClassName}></span> 
      }
      { (notificationCount || (config||{}).notificationCount) && this.renderNotication(notificationCount || config.notificationCount) }
    </div>
  }
}

Avatar.propTypes = {
  config: PropTypes.object,
  picture: PropTypes.bool
}